"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCustomAudienceRequestToJSON = exports.CreateCustomAudienceRequestFromJSONTyped = exports.CreateCustomAudienceRequestFromJSON = exports.instanceOfCreateCustomAudienceRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateCustomAudienceRequest interface.
 */
function instanceOfCreateCustomAudienceRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "audienceType" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateCustomAudienceRequest = instanceOfCreateCustomAudienceRequest;
function CreateCustomAudienceRequestFromJSON(json) {
    return CreateCustomAudienceRequestFromJSONTyped(json, false);
}
exports.CreateCustomAudienceRequestFromJSON = CreateCustomAudienceRequestFromJSON;
function CreateCustomAudienceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceType': json['audience_type'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'audienceId': !(0, runtime_1.exists)(json, 'audience_id') ? undefined : json['audience_id'],
    };
}
exports.CreateCustomAudienceRequestFromJSONTyped = CreateCustomAudienceRequestFromJSONTyped;
function CreateCustomAudienceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audience_type': value.audienceType,
        'name': value.name,
        'description': value.description,
        'audience_id': value.audienceId,
    };
}
exports.CreateCustomAudienceRequestToJSON = CreateCustomAudienceRequestToJSON;
